'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceReducer = exports.replaceActionCreator = undefined;

var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

var _yourchoice = require('yourchoice');

var _actionTypes = require('./actionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var replaceActionCreator = function replaceActionCreator(selectionName, itemId) {
  return {
    type: _actionTypes.REPLACE,
    payload: {
      selectionName: selectionName,
      itemId: itemId
    }
  };
};

var replaceReducer = function replaceReducer(_ref, currentSelection) {
  var itemId = _ref.itemId;

  (0, _assert2.default)(itemId, 'No item id (\'' + itemId + '\') to replace');

  return (0, _yourchoice.replace)(itemId, currentSelection);
};

exports.replaceActionCreator = replaceActionCreator;
exports.replaceReducer = replaceReducer;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice-redux/lib/replace.js
// module id = 73
// module chunks = 0